import React from 'react';

interface InfoFieldProps {
  label: string;
  value: string;
  mono?: boolean;
  small?: boolean;
}

export function InfoField({ label, value, mono, small }: InfoFieldProps) {
  return (
    <div>
      <div className={`${small ? 'text-xs' : 'text-sm'} font-medium text-gray-400 mb-0.5 uppercase tracking-wide`}>
        {label}
      </div>
      <div className={`${small ? 'text-md' : 'text-lg'} font-medium text-gray-900 break-all ${mono ? 'font-mono' : ''}`}>
        {value}
      </div>
    </div>
  );
}
